<template>
    <template-block
        v-if="localModel"
        type="Redeem"
        @toggle-collapsible="$emit('toggle-collapsible')"
        :open="open"
        @delete="$emit('delete')"
        :locked="value.locked"
        :position="value.position"
        :mode="mode"
        @update:locked="localModel.locked = $event; emitChange();"
        @update:position="localModel.position = $event; emitChange();"
    >
        <div class="block-content-grid">
            <select-with-validation
                v-model="localModel.fontFamily"
                :vid="vid + '.fontFamily'"
                label="Font"
                :reduce="(opt) => opt.id"
                component="ecard-template-fonts-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <select-with-validation
                v-model="localModel.fontSize"
                :vid="vid + '.fontSize'"
                label="Textstorlek"
                :reduce="(opt) => opt.id"
                component="font-size-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <select-with-validation
                v-model="localModel.lineHeight"
                :vid="vid + '.lineHeight'"
                label="Radhöjd"
                :reduce="(opt) => opt.id"
                component="font-size-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <color-picker
                :vid="vid + '.color'"
                label="Textfärg"
                v-model="localModel.color"
                @input="emitChange"
            ></color-picker>
            <color-picker
                :vid="vid + '.linkColor'"
                label="Länkfärg"
                placeholder="#4FAF4B eller ##GreetingColor##"
                :variables="['##GreetingColor##']"
                v-model="localModel.linkColor"
                @input="emitChange"
            ></color-picker>
            <input-with-validation
                label="Luft över+under"
                :vid="vid + '.paddingY'"
                v-model="localModel.paddingY"
                @input="emitChange"
                placeholder="Luft över+under"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <input-with-validation
                label="Luft vänster+höger"
                :vid="vid + '.paddingX'"
                v-model="localModel.paddingX"
                @input="emitChange"
                placeholder="Luft vänster+höger"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <input-with-validation
                label="Knappbredd"
                :vid="vid + '.width'"
                v-model="localModel.width"
                @input="emitChange"
                placeholder="Knappbredd"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <color-picker
                :vid="vid + '.buttonColor'"
                label="Knappfärg"
                placeholder="#4FAF4B eller ##GreetingColor##"
                :variables="['##GreetingColor##']"
                v-model="localModel.buttonColor"
                @input="emitChange"
            ></color-picker>
            <color-picker
                :vid="vid + '.buttonTextColor'"
                label="Knapptextfärg"
                v-model="localModel.buttonTextColor"
                @input="emitChange"
            ></color-picker>
            <input-with-validation
                label="Hörnradie"
                :vid="vid + '.borderRadius'"
                v-model="localModel.borderRadius"
                @input="emitChange"
                placeholder="Hörnradie"
            >
                <template v-slot:input-group-append>
                    <span class="input-group-text">px</span>
                </template>
            </input-with-validation>
            <select-with-validation
                v-model="localModel.align"
                :vid="vid + '.align'"
                label="Knapp-placering"
                :reduce="(opt) => opt.id"
                :options="[
                    { label: 'Vänster', id: 'left' },
                    { label: 'Centrerad', id: 'center' },
                    { label: 'Höger', id: 'right' },
                ]"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
        </div>
    </template-block>
</template>

<script>
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import { genUUID } from '@services/Helpers';
import ColorPicker from '@components/Form/ColorPicker.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import InputWithValidation from '@components/Form/InputWithValidation.vue';

export default {
    name: 'BlockRedeem',
    components: {
        InputWithValidation,
        SelectWithValidation,
        ColorPicker,
        TemplateBlock,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        vid: {
            type: String,
            default: 'image.',
        },
        open: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        localModel: null,
    }),
    mounted() {
        this.init(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
            },
        },
        fontSize(newVal) {
            this.localModel.lineHeight = newVal + 4;
            this.emitChange();
        },
    },
    methods: {
        init(newVal) {
            this.localModel = {
                type: 'redeem',
                id: newVal.id || genUUID(),
                align: newVal.align || 'center',
                buttonColor: newVal.buttonColor || '#4FAF4B',
                buttonTextColor: newVal.buttonTextColor || '#FFFFFF',
                paddingY: newVal.paddingY ?? 10,
                paddingX: newVal.paddingX ?? 25,
                color: newVal.color || '#222222',
                linkColor: newVal.linkColor || '#4FAF4B',
                fontSize: newVal.fontSize ?? 14,
                lineHeight: newVal.lineHeight ?? 20,
                fontFamily: newVal.fontFamily || 'inherit',
                borderRadius: newVal.borderRadius ?? 3,
                width: newVal.width ?? 200,
                locked: newVal.locked === undefined || newVal.locked === null ? false : newVal.locked,
            };
        },
        emitChange() {
            this.$emit('input', { ...this.localModel });
        },
    },
};
</script>
